import { t } from "@lingui/macro";
import * as React from "react";
import { Rect } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const DashboardIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 24 24" title={t`Dashboard`} {...props}>
    <Rect
      x={3}
      y={3}
      width={7}
      height={10}
      rx={1}
      stroke="currentColor"
      strokeWidth={1.5}
    />
    <Rect
      x={14}
      y={3}
      width={7}
      height={6}
      rx={1}
      stroke="currentColor"
      strokeWidth={1.5}
    />
    <Rect
      x={3}
      y={17}
      width={7}
      height={4}
      rx={1}
      stroke="currentColor"
      strokeWidth={1.5}
    />
    <Rect
      x={14}
      y={13}
      width={7}
      height={8}
      rx={1}
      stroke="currentColor"
      strokeWidth={1.5}
    />
  </Icon>
);
